export default __webpack_public_path__ + "static/media/14.992e0ab6.jpg";